module.exports = __webpack_public_path__ + "img/assist_write.a868cd09.png";